import fly, { genFormData } from './fly'
import { getAuth } from '@/util/storage'
const auth = getAuth()
//缴费基本信息
export const fetchPayBase = (checkin_id?: string) => {
  return fly.get('/base/checkin/base.json', { checkin_id, auth })
}

// 支付
export const postPaying = (params: Object) =>
  fly.post('/base/checkin/payConfig.json', genFormData({ auth, ...params }))

//智能电表电费梯度
export const electricConfigApi = (checkin_id: string) =>
  fly.get('/base/checkin/electricConfig.json', { checkin_id, auth })

// 添加账单
export const postAddBill = (params: Object) =>
  fly.post('/base/bill/add.json', genFormData({ auth, ...params }))

// 获取冷水费用明细
export const fetchColdWater = (checkin_id: string) =>
  fly.get('/base/checkin/ColdWaterFeeConfig.json', { auth, checkin_id })

//  获取押金
export const fetchDeposit = (checkin_id: string) =>
  fly.get('/base/checkin/depositConfig.json', { auth, checkin_id })

//获取首页缴费基本信息
export const fetchCheckinBase = (checkin_id: string) =>
  fly.get('/base/checkin/base.json', { auth, checkin_id })
//获取账单待付款列表
export const pendingPayListApi = (checkin_id: string) =>
  fly.get('/base/bill/list.json', { checkin_id, auth })
//账单支付
export const payBillApi = (params: Object) =>
  fly.post('/base/checkin/payConfig.json', genFormData({ auth, ...params }))
//获取已付款账单列表
export const completedPayListApi = (checkin_id: string, max_time: string) =>
  fly.get('/base/checkin/payLog.json', { checkin_id, auth, max_time, size: 10 })
//删除账单
export const delBillApi = (params: Object) =>
  fly.post('/base/bill/del.json', genFormData({ auth, ...params }))

//通用查询各个项目缴费记录
export const commonBillListApi = (
  url: string,
  checkin_id: string,
  max_time: string,
) => fly.get(url, { checkin_id, auth, max_time, size: 10 })

//重置网络密码
export const resetNetPassword = (checkin_id: string) =>
  fly.get('/base/checkin/resetNetWork.json', { auth, checkin_id })
//添加未缴纳的冷水费欠款 至账单
export const addBillForceApi = (params: Object) =>
  fly.post('/base/bill/force.json', genFormData({ auth, ...params }))
